/* RESPONSIBLE TEAM: team-email */

export interface MergedIntoUserContextWireFormat {
  original_lead_id: string;
  user_id: string;
}

export interface MergedIntoUserContextConstructorFormat {
  originalLeadId: string;
  userId: string;
}

export default class MergedIntoUserContext {
  readonly originalLeadId: string;
  readonly userId: string;

  constructor(inputs: MergedIntoUserContextConstructorFormat) {
    this.originalLeadId = inputs.originalLeadId;
    this.userId = inputs.userId;
  }

  static deserialize(json: MergedIntoUserContextWireFormat): MergedIntoUserContext {
    return new MergedIntoUserContext({
      originalLeadId: json.original_lead_id,
      userId: json.user_id,
    });
  }
}
